module.exports = __webpack_public_path__ + "static/media/Tentacruel_gaussian2.8bdebfb0.png";